import loadable from '@loadable/component';

export const AsyncTrustpilot = loadable(
    () =>
        import(
            /* webpackChunkName: "async-trustpilot" */
            './'
        ),
    {ssr: false}
);

AsyncTrustpilot.displayName = 'AsyncTrustpilot';
